import { Context } from '@nuxt/types'
import { useUserStore } from '~/store/user'

export default async function ({ $pinia, i18n }: Context) {
  const userStore = useUserStore($pinia)
  // need to set locale for translations on both server and client
  await i18n.setLocale(userStore.selectedLanguage || i18n.defaultLocale)
}
